module.exports = __webpack_public_path__ + "static/media/button1.36e45724.png";